var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-snackbar', _vm._b({
    style: {
      marginTop: `${-((_vm.alerts.length - (_vm.index + 1)) * (48 + 8))}px`
    },
    attrs: {
      "timeout": "2000"
    },
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'v-snackbar', {
    absolute: true,
    bottom: true,
    text: true,
    elevation: 0,
    class: 'room-alert'
  }, false), [_c('span', [_vm._v(" " + _vm._s(_vm.alert) + " ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }